import React from "react"
import { IconProps } from "types/icon"

const Search: React.FC<IconProps> = ({
  size = 19
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.6469 15.2873C9.34515 15.2873 10.9948 14.7207 12.3346 13.6771L17.3892 18.7318C17.7668 19.0964 18.3685 19.086 18.7332 18.7084C19.0889 18.34 19.0889 17.7561 18.7332 17.3878L13.6786 12.3332C16.268 8.99985 15.665 4.19848 12.3317 1.60901C8.99835 -0.98046 4.19701 -0.377463 1.60754 2.95588C-0.981925 6.28923 -0.378928 11.0906 2.95442 13.6801C4.29639 14.7226 5.94754 15.2881 7.6469 15.2873ZM3.58557 3.58412C5.82861 1.34104 9.46528 1.341 11.7084 3.58403C13.9514 5.82707 13.9515 9.46374 11.7084 11.7068C9.46541 13.9499 5.82873 13.9499 3.58566 11.7069C3.58561 11.7069 3.58561 11.7069 3.58557 11.7068C1.34254 9.48013 1.32932 5.85671 3.55601 3.61368C3.56585 3.60379 3.57569 3.59396 3.58557 3.58412Z" fill="currentColor" />
    </svg>
  )
}

export default Search
